import { smsTemplatePopulatedSchema } from "@redotech/redo-model/sms-template";
import * as z from "zod/v4";

export const getSmsTemplateByIdPopulated = {
  name: "getSmsTemplateByIdPopulated" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ template: smsTemplatePopulatedSchema }),
};
